export default __webpack_public_path__ + "static/media/BEL2018_Coastal_Swatch_Mega_Bergerac_Harvest_Blend.77851b03.jpg";